import type { SVGProps } from "react";

export const Trash = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="size-4"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.592 3.625h-3.271c-.162-2.212-1.406-2.527-2.625-2.527-1.22 0-2.463.315-2.625 2.527H1.799v1.01h1.224l.642 6.885a2.189 2.189 0 0 0 2.175 1.961H9.55c1.13 0 2.06-.857 2.175-1.958v-.009l.64-6.878h1.226v-1.01ZM7.696 2.11c.794 0 1.482.017 1.607 1.516H6.088c.125-1.5.814-1.516 1.608-1.516Zm3.026 9.304a1.178 1.178 0 0 1-1.17 1.057H5.838a1.175 1.175 0 0 1-1.168-1.044v-.006l-.63-6.784h7.313l-.632 6.777Z"
      />
    </svg>
  );
};
